import { Component } from '@angular/core';

@Component({
  selector: 'app-hr',
  imports: [],
  templateUrl: './hr.component.html'
})
export class HrComponent {

}
